import telegramStarsApi from './telegramStarsApi'
import sbpApi from './sbpApi'
import sbp2Api from './sbp2Api'
import cryptoApi from './cryptoApi'
import uzsApi from './uzsApi'
import uzs2Api from './uzs2Api'
import kztApi from './kztApi'
import kzt2Api from './kzt2Api'
import tjsApi from './tjsApi'
import kgsApi from './kgsApi'
import uahApi from './uahApi'
import bynApi from './bynApi'
import cardApi from './cardApi'
import cardwwApi from './cardwwApi'
import cardww2Api from './cardww2Api'
import cardww3Api from './cardww3Api'
import cardww4Api from './cardww4Api'
import cardww5Api from './cardww5Api'
import cardww6Api from './cardww6Api'
import skinsApi from './skinsApi'
import apiService from '../../../services/api'
// import cryptoApi from './cryptoApi' // Будет добавлено позже
// import cardApi from './cardApi' // Будет добавлено позже

/**
 * Payment API Router
 * Общий роутер для всех способов оплаты
 * Направляет запросы к соответствующим API сервисам
 */

// Константы способов оплаты
export const PAYMENT_METHODS = {
  TELEGRAM_STARS: 'telegram_stars',
  SBP: 'sbp', // СБП - Система Быстрых Платежей (РФ)
  SBP2: 'sbp2', // СБП #2 - альтернативный метод
  CRYPTO: 'crypto', // Криптовалюта
  UZS: 'uzs', // Узбекистан (UZS) - P2P перевод на карту
  CARD: 'card', // Банковские карты
  CARDWW1: 'cardww1', // Международные банковские карты VISA/MC (резервный провайдер, #2)
  CARDWW2: 'cardww2', // Международные банковские карты VISA/MC (основной провайдер OverPay, #1)
  CARDWW3: 'cardww3', // Международные банковские карты VISA/MC (провайдер Fride, #3)
  CARDWW4: 'cardww4', // Международные банковские карты VISA/MC (провайдер Softkeys)
  CARDWW5: 'cardww5', // Международные банковские карты VISA/MC (провайдер Paytree)
  CARDWW6: 'cardww6', // Международные банковские карты VISA/MC (провайдер EasyPay, страница Stripe)
  GOOGLE_PAY: 'google_pay', // Google Pay (визуальная карточка, использует API cardww4)
  APPLE_PAY: 'apple_pay', // Apple Pay (визуальная карточка, использует API cardww4)
  KZT_CARDWW4: 'kzt_cardww4', // KZT Visa / MasterCard (визуальная карточка, использует API cardww4)
  SKINS: 'skins', // Пополнение скинами Steam
  KZT1: 'kzt1', // Казахстан (KZT) - P2P перевод в тенге
  UZS2: 'uzs2', // Узбекистан (UZS) - провайдер Exotic, P2P перевод на карту
  UZS3: 'uzs3',
  UZS4: 'uzs4',
  UZS5: 'uzs5',
  UZS6: 'uzs6',
  UZS7: 'uzs7',
  TJS1: 'tjs1', // Таджикистан (TJS) - Noros, платёжная страница
  KGS1: 'kgs1',
  KZT2: 'kzt2',
  UAH1: 'uah1',
  BYN1: 'byn1'
}

// Метаданные способов оплаты
// Названия и описания берутся из переводов i18n (payment.methods.*)
export const PAYMENT_METHODS_META = {
  [PAYMENT_METHODS.TELEGRAM_STARS]: {
    id: PAYMENT_METHODS.TELEGRAM_STARS,
    icon: 'Star',
    available: true, // Уже реализовано
    minAmount: 100,
    maxAmount: 17500
  },
  [PAYMENT_METHODS.SBP]: {
    id: PAYMENT_METHODS.SBP,
    icon: 'Smartphone',
    available: true, // Реализовано
    minAmount: 100,
    maxAmount: 50000
  },
  [PAYMENT_METHODS.SBP2]: {
    id: PAYMENT_METHODS.SBP2,
    icon: 'Smartphone',
    available: true, // Реализовано
    minAmount: 100,
    maxAmount: 50000
  },
  [PAYMENT_METHODS.CRYPTO]: {
    id: PAYMENT_METHODS.CRYPTO,
    icon: 'Bitcoin',
    available: true, // Реализовано
    minAmount: 2,
    maxAmount: 100000
  },
  [PAYMENT_METHODS.UZS]: {
    id: PAYMENT_METHODS.UZS,
    icon: 'Uzbekistan',
    available: true, // Реализовано
    minAmount: 20000,
    maxAmount: 30000000
  },
  [PAYMENT_METHODS.CARD]: {
    id: PAYMENT_METHODS.CARD,
    icon: 'CreditCard',
    available: true, // Реализовано (card1)
    minAmount: 100,
    maxAmount: 50000
  },
  [PAYMENT_METHODS.CARDWW1]: {
    id: PAYMENT_METHODS.CARDWW1,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww1) - резервный провайдер, показывается как #2
    minAmount: 10,
    maxAmount: 5000
  },
  [PAYMENT_METHODS.CARDWW2]: {
    id: PAYMENT_METHODS.CARDWW2,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww2) - основной провайдер OverPay, показывается как #1
    minAmount: 2,
    maxAmount: 5000
  },
  [PAYMENT_METHODS.CARDWW3]: {
    id: PAYMENT_METHODS.CARDWW3,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww3) - провайдер Fride, показывается как #3
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.CARDWW4]: {
    id: PAYMENT_METHODS.CARDWW4,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww4) - провайдер Softkeys, Visa/MasterCard
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.CARDWW5]: {
    id: PAYMENT_METHODS.CARDWW5,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww5) - провайдер Paytree, Visa/MasterCard
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.CARDWW6]: {
    id: PAYMENT_METHODS.CARDWW6,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww6) - провайдер EasyPay (Stripe Checkout), Visa/MasterCard
    minAmount: 10.15,
    maxAmount: 1000
  },
  [PAYMENT_METHODS.GOOGLE_PAY]: {
    id: PAYMENT_METHODS.GOOGLE_PAY,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww4) - Google Pay, использует API cardww4
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.APPLE_PAY]: {
    id: PAYMENT_METHODS.APPLE_PAY,
    icon: 'CreditCard',
    available: true, // Реализовано (cardww4) - Apple Pay, использует API cardww4
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.KZT_CARDWW4]: {
    id: PAYMENT_METHODS.KZT_CARDWW4,
    icon: 'Kazakhstan',
    available: true, // Реализовано (cardww4) - KZT Visa/MasterCard, использует API cardww4
    minAmount: 5,
    maxAmount: 2000
  },
  [PAYMENT_METHODS.SKINS]: {
    id: PAYMENT_METHODS.SKINS,
    icon: 'Steam',
    available: true, // Всегда доступно
    minAmount: 0,
    maxAmount: 0
  },
  [PAYMENT_METHODS.KZT1]: {
    id: PAYMENT_METHODS.KZT1,
    icon: 'Kazakhstan',
    available: true, // По задаче показываем всегда
    minAmount: 1000,
    maxAmount: 900000
  },
  [PAYMENT_METHODS.UZS2]: {
    id: PAYMENT_METHODS.UZS2,
    icon: 'Uzbekistan',
    available: true,
    minAmount: 20000,
    maxAmount: 30000000
  },
  [PAYMENT_METHODS.UZS3]: {
    id: PAYMENT_METHODS.UZS3,
    icon: 'Uzbekistan',
    available: true
  },
  [PAYMENT_METHODS.UZS4]: {
    id: PAYMENT_METHODS.UZS4,
    icon: 'Uzbekistan',
    available: true
  },
  [PAYMENT_METHODS.UZS5]: {
    id: PAYMENT_METHODS.UZS5,
    icon: 'Uzbekistan',
    available: true
  },
  [PAYMENT_METHODS.UZS6]: {
    id: PAYMENT_METHODS.UZS6,
    icon: 'Uzbekistan',
    available: true
  },
  [PAYMENT_METHODS.UZS7]: {
    id: PAYMENT_METHODS.UZS7,
    icon: 'Uzbekistan',
    available: true
  },
  [PAYMENT_METHODS.TJS1]: {
    id: PAYMENT_METHODS.TJS1,
    icon: 'Tajikistan',
    available: true, // По задаче показываем всегда
    minAmount: 10,
    maxAmount: 18000
  },
  [PAYMENT_METHODS.KZT2]: {
    id: PAYMENT_METHODS.KZT2,
    icon: 'Kazakhstan',
    available: true,
    minAmount: 1000,
    maxAmount: 80000
  },
  [PAYMENT_METHODS.KGS1]: {
    id: PAYMENT_METHODS.KGS1,
    icon: 'Kyrgyzstan',
    available: true,
    minAmount: 300,
    maxAmount: 300000
  },
  [PAYMENT_METHODS.UAH1]: {
    id: PAYMENT_METHODS.UAH1,
    icon: 'Ukraine',
    available: true,
    minAmount: 300,
    maxAmount: 30000
  },
  [PAYMENT_METHODS.BYN1]: {
    id: PAYMENT_METHODS.BYN1,
    icon: 'Belarus',
    available: true,
    minAmount: 10,
    maxAmount: 500
  }
}

/**
 * Получить список доступных способов оплаты
 * @returns {Array} Массив доступных способов оплаты
 */
export const getAvailablePaymentMethods = () => {
  const methodsOrder = [
    PAYMENT_METHODS.TELEGRAM_STARS,
    PAYMENT_METHODS.SKINS,
    PAYMENT_METHODS.UZS,
    PAYMENT_METHODS.UZS4,
    PAYMENT_METHODS.UZS5,
    PAYMENT_METHODS.UZS2,
    PAYMENT_METHODS.UZS3,
    PAYMENT_METHODS.UZS6,
    PAYMENT_METHODS.UZS7,
    PAYMENT_METHODS.KZT_CARDWW4,
    PAYMENT_METHODS.KZT1,
    PAYMENT_METHODS.KZT2,
    PAYMENT_METHODS.TJS1,
    PAYMENT_METHODS.KGS1,
    PAYMENT_METHODS.UAH1,
    PAYMENT_METHODS.BYN1,
    PAYMENT_METHODS.SBP,
    PAYMENT_METHODS.SBP2,
    PAYMENT_METHODS.CARD,
    // CARDWW2 — основной провайдер (подпись #1), отображается выше CARDWW1
    PAYMENT_METHODS.CARDWW2,
    // CARDWW1 — резервный провайдер (подпись #2)
    PAYMENT_METHODS.CARDWW1,
    // CARDWW3 — провайдер Fride (подпись #3)
    PAYMENT_METHODS.CARDWW3,
    // CARDWW4 — провайдер Softkeys (в UI — «Банк»)
    PAYMENT_METHODS.CARDWW4,
    // CARDWW5 — провайдер Paytree
    PAYMENT_METHODS.CARDWW5,
    // CARDWW6 — провайдер EasyPay (Stripe Checkout)
    PAYMENT_METHODS.CARDWW6,
    PAYMENT_METHODS.CRYPTO
  ]

  const backendFlagToMethod = {
    stars: PAYMENT_METHODS.TELEGRAM_STARS,
    steam: PAYMENT_METHODS.SKINS,
    sbp1: PAYMENT_METHODS.SBP,
    sbp2: PAYMENT_METHODS.SBP2,
    crypto1: PAYMENT_METHODS.CRYPTO,
    uzs1: PAYMENT_METHODS.UZS,
    uzs2: PAYMENT_METHODS.UZS2,
    uzs3: PAYMENT_METHODS.UZS3,
    uzs4: PAYMENT_METHODS.UZS4,
    uzs5: PAYMENT_METHODS.UZS5,
    uzs6: PAYMENT_METHODS.UZS6,
    uzs7: PAYMENT_METHODS.UZS7,
    kzt1: PAYMENT_METHODS.KZT1,
    kzt2: PAYMENT_METHODS.KZT2,
    tjs1: PAYMENT_METHODS.TJS1,
    kgs1: PAYMENT_METHODS.KGS1,
    uah1: PAYMENT_METHODS.UAH1,
    byn1: PAYMENT_METHODS.BYN1,
    card1: PAYMENT_METHODS.CARD,
    cardww1: PAYMENT_METHODS.CARDWW1,
    cardww2: PAYMENT_METHODS.CARDWW2,
    cardww3: PAYMENT_METHODS.CARDWW3,
    // cardww4 включает визуальные методы «Банк» и KZT Visa/MC (Google Pay и Apple Pay скрыты, пока не работают)
    cardww4: [PAYMENT_METHODS.CARDWW4, PAYMENT_METHODS.KZT_CARDWW4],
    cardww5: PAYMENT_METHODS.CARDWW5,
    cardww6: PAYMENT_METHODS.CARDWW6
  }

  const getMethodsByBackendAvailability = async () => {
    const response = await apiService.makeRequest('/api/topup/')
    const available = response?.available || {}

    const availableMethodsByBackend = new Set(
      Object.entries(available)
        .filter(([, isEnabled]) => isEnabled === true)
        .flatMap(([backendFlag]) => {
          const methods = backendFlagToMethod[backendFlag]
          return Array.isArray(methods) ? methods : [methods]
        })
        .filter(Boolean)
    )

    // Извлекаем recent_methods и конвертируем backend-ключи в frontend method IDs
    const recentBackendKeys = response?.recent_methods || []
    const recentMethodIds = new Set(
      recentBackendKeys
        .flatMap((backendKey) => {
          const methods = backendFlagToMethod[backendKey]
          return Array.isArray(methods) ? methods : [methods]
        })
        .filter(Boolean)
    )

    const methods = methodsOrder
      .map((methodId) => PAYMENT_METHODS_META[methodId])
      .filter((method) => method?.available && availableMethodsByBackend.has(method.id))

    return { methods, recentMethodIds }
  }

  return getMethodsByBackendAvailability().catch((error) => {
    console.error('❌ Ошибка получения available-методов из /api/topup/:', error)

    // Fallback: показываем локально доступные методы в фиксированном порядке
    const methods = methodsOrder
      .map((methodId) => PAYMENT_METHODS_META[methodId])
      .filter((method) => method?.available && method.id !== PAYMENT_METHODS.UZS3 && method.id !== PAYMENT_METHODS.UZS4 && method.id !== PAYMENT_METHODS.UZS5 && method.id !== PAYMENT_METHODS.UZS6 && method.id !== PAYMENT_METHODS.UZS7 && method.id !== PAYMENT_METHODS.KZT2 && method.id !== PAYMENT_METHODS.KGS1 && method.id !== PAYMENT_METHODS.UAH1 && method.id !== PAYMENT_METHODS.BYN1 && method.id !== PAYMENT_METHODS.CARDWW6)

    return { methods, recentMethodIds: new Set() }
  })
}

/**
 * Получить пакеты для конкретного способа оплаты
 * @param {string} method - Способ оплаты (telegram_stars, sbp, crypto, card)
 * @returns {Promise<Array>} Массив пакетов
 */
export const fetchPackages = async (method) => {
  switch(method) {
    case PAYMENT_METHODS.TELEGRAM_STARS:
      return await telegramStarsApi.fetchCrystalPackages()
    
    case PAYMENT_METHODS.SBP:
      return await sbpApi.fetchSbpPackages()

    case PAYMENT_METHODS.SBP2:
      return await sbp2Api.fetchSbp2Packages()

    case PAYMENT_METHODS.CRYPTO:
      return await cryptoApi.fetchCryptoPackages()

    case PAYMENT_METHODS.UZS:
      return await uzsApi.fetchUzsPackages()

    case PAYMENT_METHODS.UZS2:
      return await uzs2Api.fetchUzs2Packages()

    case PAYMENT_METHODS.UZS3:
      return await uzsApi.fetchUzsPackages('uzs3')

    case PAYMENT_METHODS.UZS4:
      return await uzsApi.fetchUzsPackages('uzs4')

    case PAYMENT_METHODS.UZS5:
      return await uzsApi.fetchUzsPackages('uzs5')

    case PAYMENT_METHODS.UZS6:
      return await uzsApi.fetchUzsPackages('uzs6')

    case PAYMENT_METHODS.UZS7:
      return await uzsApi.fetchUzsPackages('uzs7')

    case PAYMENT_METHODS.KZT1:
      return await kztApi.fetchKztPackages()

    case PAYMENT_METHODS.KZT2:
      return await kzt2Api.fetchKzt2Packages()

    case PAYMENT_METHODS.TJS1:
      return await tjsApi.fetchTjsPackages()

    case PAYMENT_METHODS.KGS1:
      return await kgsApi.fetchKgsPackages()

    case PAYMENT_METHODS.UAH1:
      return await uahApi.fetchUahPackages()

    case PAYMENT_METHODS.BYN1:
      return await bynApi.fetchBynPackages()

    case PAYMENT_METHODS.CARD:
      return await cardApi.fetchCardPackages()

    case PAYMENT_METHODS.CARDWW1:
      return await cardwwApi.fetchCardWwPackages()

    case PAYMENT_METHODS.CARDWW2:
      return await cardww2Api.fetchCardWw2Packages()

    case PAYMENT_METHODS.CARDWW3:
      return await cardww3Api.fetchCardWw3Packages()

    case PAYMENT_METHODS.CARDWW4:
    case PAYMENT_METHODS.GOOGLE_PAY:
    case PAYMENT_METHODS.APPLE_PAY:
    case PAYMENT_METHODS.KZT_CARDWW4:
      return await cardww4Api.fetchCardWw4Packages()

    case PAYMENT_METHODS.CARDWW5:
      return await cardww5Api.fetchCardWw5Packages()

    case PAYMENT_METHODS.CARDWW6:
      return await cardww6Api.fetchCardWw6Packages()

    case PAYMENT_METHODS.SKINS:
      // Для пополнения скинами нет пакетов /api/topup/
      return []
    
    default:
      throw new Error(`Неизвестный способ оплаты: ${method}`)
  }
}

/**
 * Создать платеж для конкретного способа оплаты
 * @param {string} method - Способ оплаты
 * @param {Object} data - Данные для создания платежа
 * @returns {Promise<Object>} Данные платежа
 */
export const createPayment = async (method, data) => {
  switch(method) {
    case PAYMENT_METHODS.TELEGRAM_STARS:
      return await telegramStarsApi.createInvoice(data.crystals, data.stars)
    
    case PAYMENT_METHODS.SBP:
      // СБП поддерживает два варианта: по кристаллам или по рублям
      if (data.crystals) {
        return await sbpApi.createPaymentByCrystals(data.crystals)
      } else if (data.rubles) {
        return await sbpApi.createPaymentByRubles(data.rubles)
      } else {
        throw new Error('Для СБП требуется указать crystals или rubles')
      }

    case PAYMENT_METHODS.SBP2:
      // СБП #2 поддерживает два варианта: по кристаллам или по рублям
      if (data.crystals) {
        return await sbp2Api.createPaymentByCrystals(data.crystals)
      } else if (data.rubles) {
        return await sbp2Api.createPaymentByRubles(data.rubles)
      } else {
        throw new Error('Для СБП #2 требуется указать crystals или rubles')
      }

    case PAYMENT_METHODS.CRYPTO:
      // Crypto поддерживает два варианта: по кристаллам или по USD
      if (data.crystals) {
        return await cryptoApi.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cryptoApi.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для Crypto требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.UZS:
      // UZS поддерживает два варианта: по кристаллам или по UZS
      if (data.crystals) {
        return await uzsApi.createPaymentByCrystals(data.crystals)
      } else if (data.uzs) {
        return await uzsApi.createPaymentByUzs(data.uzs)
      } else {
        throw new Error('Для UZS требуется указать crystals или uzs')
      }

    case PAYMENT_METHODS.UZS2:
      // UZS2 (Exotic) поддерживает два варианта: по кристаллам или по UZS
      if (data.crystals) {
        return await uzs2Api.createPaymentByCrystals(data.crystals)
      } else if (data.uzs) {
        return await uzs2Api.createPaymentByUzs(data.uzs)
      } else {
        throw new Error('Для UZS2 требуется указать crystals или uzs')
      }

    case PAYMENT_METHODS.UZS3:
    case PAYMENT_METHODS.UZS4:
    case PAYMENT_METHODS.UZS5:
    case PAYMENT_METHODS.UZS6:
    case PAYMENT_METHODS.UZS7:
      if (data.crystals && !data.uzs) return await uzsApi.createPaymentByCrystals(data.crystals, method)
      if (data.uzs && !data.crystals) return await uzsApi.createPaymentByUzs(data.uzs, method)
      throw new Error('Для UZS требуется указать только crystals или uzs')

    case PAYMENT_METHODS.KZT1:
      // Для KZT1 отправляем только сумму в тенге
      if (data.kzt || data.kzt1) {
        return await kztApi.createPaymentByKzt(data.kzt || data.kzt1)
      }
      throw new Error('Для KZT1 требуется указать kzt')

    case PAYMENT_METHODS.KZT2:
      if (data.crystals && !data.kzt) return await kzt2Api.createPaymentByCrystals(data.crystals)
      if (data.kzt && !data.crystals) return await kzt2Api.createPaymentByKzt(data.kzt)
      throw new Error('Для KZT2 требуется указать только crystals или kzt')

    case PAYMENT_METHODS.TJS1:
      // TJS1 поддерживает два варианта: по кристаллам или по сомони
      if (data.crystals) {
        return await tjsApi.createPaymentByCrystals(data.crystals)
      } else if (data.tjs) {
        return await tjsApi.createPaymentByTjs(data.tjs)
      } else {
        throw new Error('Для TJS1 требуется указать crystals или tjs')
      }

    case PAYMENT_METHODS.KGS1:
      if (data.crystals && !data.kgs) return await kgsApi.createPaymentByCrystals(data.crystals)
      if (data.kgs && !data.crystals) return await kgsApi.createPaymentByKgs(data.kgs)
      throw new Error('Для KGS1 требуется указать только crystals или kgs')

    case PAYMENT_METHODS.UAH1:
      if (data.crystals && !data.uah) return await uahApi.createPaymentByCrystals(data.crystals)
      if (data.uah && !data.crystals) return await uahApi.createPaymentByUah(data.uah)
      throw new Error('Для UAH1 требуется указать только crystals или uah')

    case PAYMENT_METHODS.BYN1:
      if (data.crystals && !data.byn) return await bynApi.createPaymentByCrystals(data.crystals)
      if (data.byn && !data.crystals) return await bynApi.createPaymentByByn(data.byn)
      throw new Error('Для BYN1 требуется указать только crystals или byn')

    case PAYMENT_METHODS.CARD:
      // Card поддерживает два варианта: по кристаллам или по рублям
      if (data.crystals) {
        return await cardApi.createPaymentByCrystals(data.crystals)
      } else if (data.rubles) {
        return await cardApi.createPaymentByRubles(data.rubles)
      } else {
        throw new Error('Для Card требуется указать crystals или rubles')
      }

    case PAYMENT_METHODS.CARDWW1:
      // CardWW1 поддерживает два варианта: по кристаллам или по долларам
      if (data.crystals) {
        return await cardwwApi.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cardwwApi.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для CardWW1 требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.CARDWW2:
      // CardWW2 (OverPay) поддерживает два варианта: по кристаллам или по долларам
      if (data.crystals) {
        return await cardww2Api.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cardww2Api.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для CardWW2 требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.CARDWW3:
      // CardWW3 (Fride) поддерживает два варианта: по кристаллам или по долларам
      if (data.crystals) {
        return await cardww3Api.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cardww3Api.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для CardWW3 требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.CARDWW4:
    case PAYMENT_METHODS.GOOGLE_PAY:
    case PAYMENT_METHODS.APPLE_PAY:
    case PAYMENT_METHODS.KZT_CARDWW4:
      // CardWW4 (Softkeys) поддерживает два варианта: по кристаллам или по долларам
      if (data.crystals) {
        return await cardww4Api.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cardww4Api.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для CardWW4 требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.CARDWW5:
      // CardWW5 (Paytree) поддерживает два варианта: по кристаллам или по долларам
      if (data.crystals) {
        return await cardww5Api.createPaymentByCrystals(data.crystals)
      } else if (data.dollars) {
        return await cardww5Api.createPaymentByDollars(data.dollars)
      } else {
        throw new Error('Для CardWW5 требуется указать crystals или dollars')
      }

    case PAYMENT_METHODS.CARDWW6:
      // CardWW6 (EasyPay) принимает ровно одно поле: crystal или dollar
      if (data.crystals && !data.dollars) return await cardww6Api.createPaymentByCrystals(data.crystals)
      if (data.dollars && !data.crystals) return await cardww6Api.createPaymentByDollars(data.dollars)
      throw new Error('Для CardWW6 требуется указать только crystals или dollars')

    case PAYMENT_METHODS.SKINS:
      return await skinsApi.createSkinsPaymentLink()
    
    default:
      throw new Error(`Неизвестный способ оплаты: ${method}`)
  }
}

/**
 * Открыть окно оплаты для конкретного способа
 * @param {string} method - Способ оплаты
 * @param {Object} paymentData - Данные платежа
 * @param {Function} onResult - Callback для результата
 * @param {Window} paymentWindow - Подготовленное окно оплаты для web-версии
 */
export const openPayment = (method, paymentData, onResult, paymentWindow = null) => {
  switch(method) {
    case PAYMENT_METHODS.TELEGRAM_STARS:
      telegramStarsApi.openTelegramPayment(paymentData.invoice_url, onResult)
      break
    
    case PAYMENT_METHODS.SBP:
      sbpApi.openSbpPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.SBP2:
      sbp2Api.openSbp2Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CRYPTO:
      cryptoApi.openCryptoPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.UZS:
      if (paymentData?.link) {
        uzsApi.openUzsPayment(paymentData.link, onResult, paymentWindow)
        break
      }

      if (onResult) onResult({ success: true })
      break

    case PAYMENT_METHODS.UZS3:
    case PAYMENT_METHODS.UZS4:
    case PAYMENT_METHODS.UZS6:
    case PAYMENT_METHODS.UZS7:
      uzsApi.openUzsPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.KZT1:
      kztApi.openKztPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.KZT2:
      kzt2Api.openKzt2Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.TJS1:
      tjsApi.openTjsPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.KGS1:
      kgsApi.openKgsPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.UAH1:
      uahApi.openUahPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.BYN1:
      bynApi.openBynPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARD:
      cardApi.openCardPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW1:
      cardwwApi.openCardWwPayment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW2:
      cardww2Api.openCardWw2Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW3:
      cardww3Api.openCardWw3Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW4:
    case PAYMENT_METHODS.GOOGLE_PAY:
    case PAYMENT_METHODS.APPLE_PAY:
    case PAYMENT_METHODS.KZT_CARDWW4:
      cardww4Api.openCardWw4Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW5:
      cardww5Api.openCardWw5Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.CARDWW6:
      cardww6Api.openCardWw6Payment(paymentData.link, onResult, paymentWindow)
      break

    case PAYMENT_METHODS.SKINS:
      skinsApi.openSkinsPayment(paymentData.link, onResult, paymentWindow)
      break
    
    // case PAYMENT_METHODS.CRYPTO:
    //   cryptoApi.openPayment(paymentData, onResult)
    //   break
    
    // case PAYMENT_METHODS.CARD:
    //   cardApi.openPayment(paymentData, onResult)
    //   break
    
    default:
      throw new Error(`Неизвестный способ оплаты: ${method}`)
  }
}

// Экспорт по умолчанию
export default {
  PAYMENT_METHODS,
  PAYMENT_METHODS_META,
  getAvailablePaymentMethods,
  fetchPackages,
  createPayment,
  openPayment
}
